import * as Yup from 'yup';
import { validationMessages } from '../messages/messages';

export const AddChatGroupSchema = Yup.object().shape({
  chatName: Yup.string().required(validationMessages.required),
});
